<div class="wrap">
  <mat-card *ngFor="let o of offers, let i = index" (click)="openOfferInNewTab(o.offerKey)" [id]="getIdOffer(i)"
            class="offer_start">

            <app-image-offer [matCard]="true" [offerKey]="o.offerKey" [height]="'250px'"></app-image-offer>


            <!-- <img mat-card-image [src]="getImgOffer(o.image)" alt="Photo"> -->

            <mat-card-content>
              <div class="photo_experience" *ngIf="o?.photoExperience">
                <p>{{o?.photoExperience}}</p>
              </div>
              <div class="infos_sub_img">
                <div class="infos">
                  <div class="icon">
                    <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
                  </div>
                  {{o?.duration}}
                </div>
                <div class="infos">
                  <div class="icon">
                    <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
                  </div>
                  <p>
                    {{o?.practicePlace}}
                  </p>
                </div>
              </div>

              <h4><strong>{{o.offerName}}</strong></h4>

              <div class="tags">
                <ng-container *ngFor="let t of o?.mainTags, let i = index">
                  <div class="tag">{{t.tagName}} </div>
                </ng-container>
              </div>
            </mat-card-content>

            <div class="btn_action" [id]="getIdOfferAdd(o.offerName)">
              <div class="price">
                <div class="icon">
                  <fa-icon [icon]="getFaIcon('faEuroSign')"></fa-icon>
                </div>
                <span> {{o?.price}} </span>
              </div>

              <!-- <div class="actions_offer">
                                <fa-icon class="faShoppingBasket" [icon]="faShoppingBasket"></fa-icon>
             -->
              <!-- <fa-icon [icon]="isInMyWishes(o.offerKey)" [style.color]="getColorOfHeart(o.offerKey)"
                (click)="addOrDeleteToMyWish(o, $event); $event.stopPropagation()">
              </fa-icon> -->
              <!-- </div> -->
            </div>
          </mat-card>
</div>
